import React from 'react';
import { observer,inject } from 'mobx-react';
import LoadingSpinner from '../LoadingSpinner';
import ButtonSpinner from '../ButtonSpinner';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {  Button } from 'react-bootstrap';
import Utils from '../../Utils';

@inject('policyStore')
@observer
export default class PolicyList extends React.Component {
    componentDidMount(){
        this.props.policyStore.GetPolicies();
    }
    dateFormater(cell,row){
        return Utils.Dates.ToString("dd/mm/yyyy",cell);
    }
    
    editButtonFormatter(cell,row){
        return(<Button onClick={()=>{
            this.props.policyStore.ToggleAddPolicyModal(row.DocId);
        }} >Edit</Button>);
    }
    deleteButtonFormatter(cell,row){
        return(<Button key={"btn-"+row.DocId} onClick={()=>{
            this.props.policyStore.DocIdToDelete = row.DocId;
            this.props.policyStore.DeletePolicy();
        }} >Delete <ButtonSpinner key={"spnr-"+row.DocId} IsLoading={this.props.policyStore.IsDeletingPolicy && row.DocId === this.props.policyStore.DocIdToDelete} /></Button>);
    }
   render(){
      if(!this.props.policyStore.LoadingPolicies){
        return(<BootstrapTable data={this.props.policyStore.Policies} striped={true} hover={true}>
        <TableHeaderColumn dataField="DocId" isKey={true} hidden={true}  >Id</TableHeaderColumn>
        <TableHeaderColumn dataField="DocName"  dataSort={true} >Name</TableHeaderColumn>
        <TableHeaderColumn dataField="Description" >Description</TableHeaderColumn>
        <TableHeaderColumn dataField="Category" >Category</TableHeaderColumn>
        <TableHeaderColumn dataField="ModifiedDate" dataFormat={this.dateFormater} >Modified On</TableHeaderColumn>
        <TableHeaderColumn dataField="Version" >Version</TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.editButtonFormatter.bind(this)}  >Edit</TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.deleteButtonFormatter.bind(this)}  >Delete</TableHeaderColumn>
    </BootstrapTable>);
      }
      else{
        return(<LoadingSpinner/>);
      }
   }
}


// WEBPACK FOOTER //
// ./src/components/Policies/PolicyList.js